import { ApiError, fetchWithAuth } from "@entities/user-tokens";

import type { Source } from "../Source";

/** S3 への直接アップロード完了を確定する（uploading → ready）。`name` でリネーム可。 */
export async function commitSource(
    projectId: string,
    sourceId: string,
    patch: { name?: string } = {}
): Promise<Source> {
    const res = await fetchWithAuth(`/sources/${sourceId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ projectId, ...patch }),
    });
    if (!res.ok) throw await ApiError.fromResponse(res, "受領データの確定に失敗しました");
    const body = (await res.json()) as { source: Source };
    return body.source;
}
